import { connect } from 'react-redux';
import { updateInputData } from '../../redux/product/productActions';
import Basicdata from './Basicdata';
import {  Dispatch } from "redux";
import { ApplicationState } from '../../redux/state';

const mapStateToProps = ({product} : ApplicationState) => ({
        torque: product.productInputData.torque,
        axialForce: product.productInputData.axialForce,
        rotationSpeed: product.productInputData.rotationSpeed ,
        errorFields: product.productInputData.errorFields,
        hubOuterDiameter: product.productInputData.hubOuterDiameter,
        hubInnerDiameter_D:product.currentProduct.hubInnerDiameter_D
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    inputChanged:(productInputData: any) => { dispatch(updateInputData(productInputData))}
});

const ConnectedBasicData = connect(
    mapStateToProps,
    mapDispatchToProps
)(Basicdata);

export default ConnectedBasicData;